import { render } from "./AddressDetailsSection.vue?vue&type=template&id=9cfe86a0&scoped=true"
import script from "./AddressDetailsSection.vue?vue&type=script&lang=js"
export * from "./AddressDetailsSection.vue?vue&type=script&lang=js"

import "./AddressDetailsSection.vue?vue&type=style&index=0&id=9cfe86a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cfe86a0"]])

export default __exports__